import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "team" }
const _hoisted_3 = { class: "team-wrapper" }
const _hoisted_4 = { class: "team-grid" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "placement" }
const _hoisted_7 = { class: "map-card" }
const _hoisted_8 = {
  key: 0,
  style: {"border":"0"},
  loading: "lazy",
  allowfullscreen: "",
  src: "https://www.google.com/maps?q=Musterstrasse+12,+12345+Musterstadt&output=embed"
}
const _hoisted_9 = {
  key: 1,
  class: "map-placeholder"
}
const _hoisted_10 = { class: "popup-box" }
const _hoisted_11 = { class: "popup-text" }

import * as CookieConsent from 'vanilla-cookieconsent';
import {onBeforeUnmount, onMounted, ref} from "vue";
import '@/assets/styles/about.css'


// Später auslagern
interface TeamMember {
  name: string;
  role: string;
  img?: string;
  text: string;
  certificate?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {
/**
 * Content:
 * Placement
 * Openings and Closings
 * Family Company - Philosophy
 * Experience,Quality,
 * Master and TÜV
 * Team and photos
 *
 */

const selected = ref<TeamMember | null>(null);


const team: TeamMember[] = [
  {
    name: "Max Mustermann",
    role: "Geschäftsführer & Kraftfahrzeugtechnikermeister",
    text: "Hallo! Ich bin Max, der beispielhafte Gründer dieser Musterwerkstatt.",
    certificate: '@/assets/team/teamleitung.jpeg'
  },
  {
    name: "Erika Musterfrau",
    role: "KFZ-Mechatroniker",
    text: "Hey! Ich bin Erika und halte eure Autos am Laufen.",
  }
];

const showPopup = (member: TeamMember) => {
  selected.value = member;
};

const closePopup = () => {
  selected.value = null;
};

const acceptedGoogleMaps = ref(false);

function updateConsent() {
  acceptedGoogleMaps.value =
      CookieConsent.acceptedCategory("external");
}

function openCookieSettings() {
  CookieConsent.showPreferences();
}

onMounted(() => {
  updateConsent();
  window.addEventListener("cookie-consent-changed", updateConsent);
});

onBeforeUnmount(() => {
  window.removeEventListener("cookie-consent-changed", updateConsent);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("h1", null, "Meet the Team mit einem Klick", -1)),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(team, (member) => {
            return _createElementVNode("div", {
              class: "team-card card",
              key: member.name,
              onClick: ($event: any) => (showPopup(member))
            }, [
              _createElementVNode("h3", null, _toDisplayString(member.name), 1),
              _createElementVNode("p", null, _toDisplayString(member.role), 1)
            ], 8, _hoisted_5)
          }), 64))
        ])
      ])
    ]),
    _cache[2] || (_cache[2] = _createStaticVNode("<section class=\"content\"><div class=\"card\"><h2>Über unser Unternehmen</h2> Seit unserer Gründung im Jahr 2024 stehen wir für zuverlässigen Service, moderne Technik und echte Kundennähe. Bereits 2025 konnten wir unser Team erweitern – ein wichtiger Schritt, um unseren Service weiter auszubauen und noch schneller für unsere Kunden da zu sein. Als Meisterbetrieb kümmern wir uns um Fahrzeuge aller Marken. Neben klassischen Wartungs- und Reparaturarbeiten bieten wir unter anderem auch Getriebeölspülungen an – eine Leistung, die über den herkömmlichen Getriebeölwechsel hinausgeht und von vielen Betrieben nicht angeboten wird. Dabei arbeiten wir stets mit möglichst moderner Technik, um Ihr Fahrzeug optimal zu betreuen. Was uns besonders auszeichnet, ist unser persönlicher Service: Bei uns sind Sie keine Nummer wie im großen Autohaus. Wir nehmen uns Zeit für Ihre Anliegen, beraten ehrlich und unkompliziert und gehen verantwortungsvoll mit jedem Fahrzeug um. Eine schnelle Terminvergabe gehört für uns genauso dazu wie transparente Abläufe. Als lokal verwurzeltes Unternehmen freuen wir uns über das Vertrauen unserer Kunden. Viele neue Kunden finden durch Empfehlungen zu uns, gleichzeitig dürfen wir auch langjährige Kunden weiterhin betreuen. Das bestätigt uns in unserer Arbeit – denn bei uns wird Service noch großgeschrieben. Wir freuen uns darauf, auch Sie persönlich bei uns begrüßen zu dürfen. </div></section><section class=\"opening-hours\"><div class=\"card\"><h2>Öffnungszeiten</h2><ul class=\"opening-list\"><li><span>Montag – Freitag</span><span>08:00 – 17:00 Uhr</span></li><li class=\"closed\"><span>Samstag &amp; Sonntag</span><span>Geschlossen</span></li></ul><p class=\"opening-hint\"> Termine außerhalb der Öffnungszeiten nach Vereinbarung. </p></div></section>", 2)),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (acceptedGoogleMaps.value)
          ? (_openBlock(), _createElementBlock("iframe", _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _cache[1] || (_cache[1] = _createElementVNode("p", null, "Google Maps ist deaktiviert", -1)),
              _createElementVNode("button", { onClick: openCookieSettings }, " Einstellungen öffnen ")
            ]))
      ])
    ]),
    (selected.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "popup-overlay",
          onClick: _withModifiers(closePopup, ["self"])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "close-btn",
              type: "button",
              "aria-label": "Popup schliessen",
              onClick: closePopup
            }, "x"),
            _createElementVNode("h2", null, _toDisplayString(selected.value.name), 1),
            _createElementVNode("h4", null, _toDisplayString(selected.value.role), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(selected.value.text), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})